import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/site/Layout";
import HomePage from "./pages/HomePage";
import PizzasPage from "./pages/PizzasPage";
import CartePage from "./pages/CartePage";
import OrderPage from "./pages/OrderPage";
import HallRental from "./pages/HallRental";
import PracticalInfo from "./pages/PracticalInfo";
import Contact from "./pages/Contact";
import Legal from "./pages/Legal";
import { ContentProvider } from "./lib/content";
import { CartProvider } from "./lib/cart";

function App() {
  return (
    <ContentProvider>
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/notre-carte" element={<CartePage />} />
              <Route path="/nos-pizzas" element={<PizzasPage />} />
              <Route path="/commander-a-emporter" element={<OrderPage />} />
              <Route path="/commande/confirmation" element={<Navigate to="/commander-a-emporter" replace />} />
              <Route path="/location-de-salle" element={<HallRental />} />
              <Route path="/informations-pratiques" element={<PracticalInfo />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/mentions-legales" element={<Legal page="mentions" />} />
              <Route path="/politique-de-confidentialite" element={<Legal page="confidentialite" />} />
              <Route path="/conditions-generales-de-vente" element={<Legal page="cgv" />} />
              <Route path="/cookies" element={<Legal page="cookies" />} />
              <Route path="/commander-en-ligne" element={<Navigate to="/commander-a-emporter" replace />} />
              <Route path="/a-propos" element={<Navigate to="/informations-pratiques" replace />} />
              <Route path="*" element={<HomePage />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </CartProvider>
    </ContentProvider>
  );
}

export default App;
